import { createContext, useContext, useMemo, type ReactElement, type ReactNode } from 'react';
import type { ConfigContextValue } from '../interfaces';

const ConfigContext = createContext<ConfigContextValue | null>(null);

/**
 * Everything the module needs from its host arrives here. It is the seam the module is
 * extracted along: embedded, the host fills it; standalone, its own shell does.
 */
export const ConfigProvider = ({ value, children }: { value: ConfigContextValue; children: ReactNode }): ReactElement => {
  const memoised = useMemo(() => value, [value]);

  return <ConfigContext.Provider value={memoised}>{children}</ConfigContext.Provider>;
};

export const useConfigContext = (): ConfigContextValue => {
  const value = useContext(ConfigContext);

  if (!value) {
    throw new Error('useConfigContext must be used inside a ConfigProvider');
  }

  return value;
};
